import React, { useEffect, useState } from "react";
import "./layout.css";
import { useLocation, Link } from "react-router-dom";
import Header from "fragments/header";

import { COLORS } from "constants/colors.js";

// mui
import {
  IconButton,
  Typography,
  Avatar,
  Box,
  Drawer,
  Menu,
  MenuItem,
  Fade,
} from "@mui/material";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import PersonIcon from "@mui/icons-material/Person";
import DashboardIcon from "@mui/icons-material/Dashboard";
import LogoutIcon from "@mui/icons-material/Logout";
import CloseIcon from "@mui/icons-material/Close";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import HistoryIcon from "@mui/icons-material/History";
import EditIcon from "@mui/icons-material/Edit";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import SupportIcon from "@mui/icons-material/Support";
import LiveHelpIcon from "@mui/icons-material/LiveHelp";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import { Helmet } from "react-helmet";
import { getLocalData } from "utils/storage";
import { useNavigate } from "react-router-dom";

const drawerWidth = 280;

export default function Layout({ window, children, title }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [showSideBar, setShowSideBar] = useState(false);
  const handleSideBar = () => {
    setShowSideBar(!showSideBar);
    // console.log(showSideBar);import SupportAgentIcon from '@mui/icons-material/SupportAgent';
  };

  // adminName menu
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const drawer = (
    <div className="drawer">
      <div className="logoContainer">
        <div className="drawerMenuIcon">
          <IconButton onClick={handleSideBar} sx={{ color: COLORS.primary }}>
            <CloseIcon sx={{ fontSize: "35px", color: COLORS.primary }} />
          </IconButton>
        </div>
        <div className="flex gap-2 items-center w-full justify-center max-[900px]:mr-14">
          {/* <img alt="" src="/amirazz.png" className="w-10" /> */}
          <Typography sx={{ color: COLORS.yellow, fontWeight: "bold" }}>
            {/* Amirazz */}
          </Typography>
        </div>
      </div>
      <div className="flex flex-col justify-center w-full items-center mt-10">
        <div className="border-solid border-2 border-gray_light rounded-full p-1">
          <div className="border-solid border-4 border-gray_light rounded-full">
            <Avatar
              sx={{
                width: "70px",
                height: "70px",
                backgroundColor: COLORS.primary,
                margin: "5px",
              }}
            />
          </div>
        </div>
        <div className="flex cursor-pointer" onClick={handleClick}>
          <Typography sx={{ fontWeight: "bold", color: COLORS.primary }}>
            Admin
          </Typography>
          {anchorEl ? (
            <ArrowDropUpIcon sx={{ color: COLORS.primary }} />
          ) : (
            <ArrowDropDownIcon sx={{ color: COLORS.primary }} />
          )}
        </div>
        <Typography className="opacity-50 italic">admin@gmail.com</Typography>
      </div>
      <Menu
        TransitionComponent={Fade}
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        PaperProps={{
          elevation: 0,
          sx: {
            // backgroundColor: COLORS.indigo,
            color: COLORS.primary,
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.12))",
            mt: 1.5,
            width: "200px",
          },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}>
        <Link to="/admin-profile">
          <MenuItem onClick={handleClose}>
            <PersonIcon sx={{ margin: "0 15px 0 0 " }} />
            <Typography>My Profile</Typography>
          </MenuItem>
        </Link>
        <Link to="/">
          <MenuItem onClick={handleClose}>
            <LogoutIcon sx={{ margin: "0 15px 0 0 " }} />
            <Typography>Logout</Typography>
          </MenuItem>
        </Link>
      </Menu>
      <div className="flex flex-col gap-2 justify-center items-center mt-8">
        <Link to="/dashboard">
          <div
            className="flex gap-3 items-center w-60 hover:bg-yellow transition-all px-4 py-4 rounded-xl"
            style={
              location.pathname.includes("/dashboard")
                ? {
                    backgroundColor: COLORS.primary,
                    color: COLORS.white,
                  }
                : {
                    color: COLORS.primary,
                    cursor: "pointer",
                  }
            }>
            <DashboardIcon
              sx={
                location.pathname.includes("/dashboard")
                  ? {
                      backgroundColor: COLORS.primary,
                      color: COLORS.white,
                    }
                  : {
                      color: COLORS.primary,
                      cursor: "pointer",
                    }
              }
            />
            <Typography
              sx={
                location.pathname.includes("/dashboard")
                  ? {
                      backgroundColor: COLORS.primary,
                      color: COLORS.white,
                    }
                  : {
                      color: COLORS.primary,
                      cursor: "pointer",
                    }
              }>
              Dashboard
            </Typography>
          </div>
        </Link>

        <Link to="/users">
          <div
            className="flex gap-3 items-center w-60 hover:bg-yellow hover:color-white  px-4 py-4  rounded-xl"
            style={
              location.pathname.includes("/users")
                ? {
                    backgroundColor: COLORS.primary,
                    color: COLORS.white,
                  }
                : {
                    color: COLORS.black,
                    cursor: "pointer",
                  }
            }>
            <PeopleAltIcon
              style={
                location.pathname.includes("/users")
                  ? {
                      backgroundColor: COLORS.primary,
                      color: COLORS.white,
                    }
                  : {
                      color: COLORS.primary,
                      cursor: "pointer",
                    }
              }
            />
            <Typography
              style={
                location.pathname.includes("/users")
                  ? {
                      backgroundColor: COLORS.primary,
                      color: COLORS.white,
                    }
                  : {
                      color: COLORS.primary,
                      cursor: "pointer",
                    }
              }>
              Users
            </Typography>
          </div>
        </Link>

        {/* <Link to="/subscription-packages">
          <div
            className="flex gap-3 items-center w-60 hover:bg-yellow hover:color-white  px-4 py-4 rounded-xl"
            style={
              location.pathname.includes("/subscription-packages")
                ? {
                    backgroundColor: COLORS.primary,
                    color: COLORS.white,
                  }
                : {
                    color: COLORS.black,
                    cursor: "pointer",
                  }
            }>
            <SubscriptionsIcon
              style={
                location.pathname.includes("/subscription-packages")
                  ? {
                      backgroundColor: COLORS.primary,
                      color: COLORS.white,
                    }
                  : {
                      color: COLORS.primary,
                      cursor: "pointer",
                    }
              }
            />
            <Typography
              style={
                location.pathname.includes("/subscription-packages")
                  ? {
                      backgroundColor: COLORS.primary,
                      color: COLORS.white,
                    }
                  : {
                      color: COLORS.primary,
                      cursor: "pointer",
                    }
              }>
              Subscription Packages
            </Typography>
          </div>
        </Link> */}

        <Link to="/chaperoneChats">
          <div
            className="flex gap-3 items-center w-60 hover:bg-yellow hover:color-white  px-4 py-4  rounded-xl"
            style={
              location.pathname.includes("/chaperoneChats")
                ? {
                    backgroundColor: COLORS.primary,
                    color: COLORS.white,
                  }
                : {
                    color: COLORS.black,
                    cursor: "pointer",
                  }
            }>
            <SupportIcon
              style={
                location.pathname.includes("/chaperoneChats")
                  ? {
                      backgroundColor: COLORS.primary,
                      color: COLORS.white,
                    }
                  : {
                      color: COLORS.primary,
                      cursor: "pointer",
                    }
              }
            />
            <Typography
              style={
                location.pathname.includes("/chaperoneChats")
                  ? {
                      backgroundColor: COLORS.primary,
                      color: COLORS.white,
                    }
                  : {
                      color: COLORS.primary,
                      cursor: "pointer",
                    }
              }>
              Chaperone Support
            </Typography>
          </div>
        </Link>

        <Link to="/latin-support/chats">
          <div
            className="flex gap-3 items-center w-60 hover:bg-yellow hover:color-white  px-4 py-4  rounded-xl"
            style={
              location.pathname.includes("/latin-support")
                ? {
                    backgroundColor: COLORS.primary,
                    color: COLORS.white,
                  }
                : {
                    color: COLORS.black,
                    cursor: "pointer",
                  }
            }>
            <LiveHelpIcon
              style={
                location.pathname.includes("/latin-support")
                  ? {
                      backgroundColor: COLORS.primary,
                      color: COLORS.white,
                    }
                  : {
                      color: COLORS.primary,
                      cursor: "pointer",
                    }
              }
            />
            <Typography
              style={
                location.pathname.includes("/latin-support")
                  ? {
                      backgroundColor: COLORS.primary,
                      color: COLORS.white,
                    }
                  : {
                      color: COLORS.primary,
                      cursor: "pointer",
                    }
              }>
              Latin Supportort
            </Typography>
          </div>
        </Link>

        <Link to="/revert-support/chats">
          <div
            className="flex gap-3 items-center w-60 hover:bg-yellow hover:color-white  px-4 py-4  rounded-xl"
            style={
              location.pathname.includes("/revert-support")
                ? {
                    backgroundColor: COLORS.primary,
                    color: COLORS.white,
                  }
                : {
                    color: COLORS.black,
                    cursor: "pointer",
                  }
            }>
            <ContactSupportIcon
              style={
                location.pathname.includes("/revert-support")
                  ? {
                      backgroundColor: COLORS.primary,
                      color: COLORS.white,
                    }
                  : {
                      color: COLORS.primary,
                      cursor: "pointer",
                    }
              }
            />
            <Typography
              style={
                location.pathname.includes("/revert-support")
                  ? {
                      backgroundColor: COLORS.primary,
                      color: COLORS.white,
                    }
                  : {
                      color: COLORS.primary,
                      cursor: "pointer",
                    }
              }>
              Revert Support
            </Typography>
          </div>
        </Link>

        <Link to="/expert-support/chats" className="mb-5">
          <div
            className="flex gap-3 items-center w-60 hover:bg-yellow hover:color-white  px-4 py-4  rounded-xl"
            style={
              location.pathname.includes("/expert-support")
                ? {
                    backgroundColor: COLORS.primary,
                    color: COLORS.white,
                  }
                : {
                    color: COLORS.black,
                    cursor: "pointer",
                  }
            }>
            <SupportAgentIcon
              style={
                location.pathname.includes("/expert-support")
                  ? {
                      backgroundColor: COLORS.primary,
                      color: COLORS.white,
                    }
                  : {
                      color: COLORS.primary,
                      cursor: "pointer",
                    }
              }
            />
            <Typography
              style={
                location.pathname.includes("/expert-support")
                  ? {
                      backgroundColor: COLORS.primary,
                      color: COLORS.white,
                    }
                  : {
                      color: COLORS.primary,
                      cursor: "pointer",
                    }
              }>
              Expert Support
            </Typography>
          </div>
        </Link>
      </div>
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  useEffect(() => {
    const user = getLocalData("user");
    if (!user) {
      navigate("/");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Helmet>
        <link
          rel="shortcut icon"
          href={location.pathname !== "/" && "/favicon.png"}
          type="image/x-icon"
        />
        <title>{title}</title>
      </Helmet>
      <Header onMenuClick={handleSideBar} />
      <div className="flex">
        <Box
          className="drawer"
          // component="nav"
          // sx={{ width:  }, flexShrink: { sm: 0 } }}
          aria-label="mailbox folders">
          <Drawer
            container={container}
            variant="temporary"
            open={showSideBar}
            onClose={handleSideBar}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              display: { xs: "block", sm: "block" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
                borderRadius: "15px",
                // overflow: "hidden",
                margin: "10px",
                height: "97%",
                "&::-webkit-scrollbar": {
                  width: "0px",
                },
              },
            }}>
            {drawer}
          </Drawer>
          <Drawer
            variant="permanent"
            sx={{
              display: { xs: "none", sm: "none", md: "block" },
              overflow: "hidden",
              borderRadius: "10px",
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
              },
            }}
            open>
            {drawer}
          </Drawer>
        </Box>
        <Box component="main" sx={{ width: "100%", marginTop: "3.5rem" }}>
          <div className="main_children">{children}</div>
        </Box>
      </div>
    </>
  );
}

Layout.defaultProps = {
  title: "Amirazz Admin Panel",
  description: "robots",
  keywords: "noindex, nofollow",
};
